import axios from "axios";
import { AccountApi, Configuration, DataPacksApi, EventsApi, MarketingApi, ReportsApi, SurveysApi } from "./generated";

import msalInstance, { acquireAccessToken } from "../auth";

const basePath = process.env.REACT_APP_API_BASE_URL;
const bypassAuth = process.env.REACT_APP_BYPASS_AUTH === "true";

if (!basePath) {
  throw new Error("API base URL not defined");
}

const config = new Configuration({
  basePath,
  accessToken: !bypassAuth ? acquireAccessToken : void 0,
});

const axiosInstance = axios.create();

// True when running the API locally
const noApim = process.env.REACT_APP_API_NO_APIM === "true";

if (noApim) {
  axiosInstance.interceptors.request.use(config => {
    const account = msalInstance.getAllAccounts()[0];
    if (account) {
      const claims = account.idTokenClaims as any;
      config.params = {
        contactId: process.env.REACT_APP_CONTACT_ID ?? claims?.contactId,
        partnerId: process.env.REACT_APP_PARTNER_ID ?? claims?.partnerId,
        partnerName: process.env.REACT_APP_PARTNER_NAME ?? claims?.partnerName,
      };
    }
    else {
      config.params = {
        contactId: process.env.REACT_APP_CONTACT_ID ?? "",
        partnerId: process.env.REACT_APP_PARTNER_ID ?? "",
        partnerName: process.env.REACT_APP_PARTNER_NAME ?? "",
      };
    }
    return config;
  });
}

export const accountApi = new AccountApi(config, void 0, axiosInstance);
export const eventsApi = new EventsApi(config, void 0, axiosInstance);
export const dataPacksApi = new DataPacksApi(config, void 0, axiosInstance);
export const marketingApi = new MarketingApi(config, void 0, axiosInstance);
export const reportsApi = new ReportsApi(config, void 0, axiosInstance);
export const surveysApi = new SurveysApi(config, void 0, axiosInstance);

export * from "./models";
export * from "./generated";
